
import React from 'react';
import * as _ from 'lodash';
import { useNavigate } from 'react-router';
import { useStore } from '@nanostores/react';
import { $productConfig } from '../../stores/Config.jsx';



export default ({}) => {
    const
        conf = useStore($productConfig),
        navigate = useNavigate(),
        //
        onFinishClicked = () => {
            document.location.href = conf.return_url;
        },
        onRestartClicked = () => {
            navigate('/');
        };

    return (
        <div className="card border-success mb-2">
            <div className="card-header text-bg-success">
                Заявление успешно отправлено
            </div>
            <div className="card-body">
                <p>
                    Ваше заявление успешно отправлено в приёмную комиссию техникума.
                </p>
                <p>
                    Для окончательного оформления документа Вам <strong>необходимо подойти в приёмную комиссию</strong> техникума <strong>лично
                    с одним из родителей</strong> (законных представителей).
                </p>
                <p style={{color:"darkred"}}>
                    <strong>Приём по предварительной записи</strong>.
                    Записаться необходимо по телефону <a href="tel:+73412432388">(3412) 43-23-88</a>.
                </p>
                <p>
                    Для оформления будут необходимы:
                </p>
                <ul>
                    <li>Оригинал документа, удостоверяющего личность (паспорт);</li>
                    <li>Оригинал документа об образовании (аттестат);</li>
                    <li>СНИЛС;</li>
                    <li>Четыре фотографии размером 3x4 см, матовые;</li>
                    <li>Справка обязательного медицинского осмотра по форме 086-у.</li>
                </ul>
                <p>
                    <strong>График работы приёмной комиссии:</strong> с 09:00 до 16:00 ежедневно кроме субботы и воскресенья,
                    технический перерыв с 11:30 до 13:00.
                </p>
            </div>
            <div className="card-body">
                <button type="button" className="btn btn-primary" onClick={onFinishClicked}>
                    <i className="bi bi-check" /> Завершить
                </button>
                <button type="button" className="btn btn-link" onClick={onRestartClicked}>
                    Заполнить ещё одно заявление
                </button>
            </div>
        </div>
    );
}